var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVideoCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/video-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5001 2.16602C7.52008 2.16602 2.66675 7.01935 2.66675 12.9993C2.66675 18.9794 7.52008 23.8327 13.5001 23.8327C19.4801 23.8327 24.3334 18.9794 24.3334 12.9993C24.3334 7.01935 19.4801 2.16602 13.5001 2.16602ZM16.3817 14.8735L14.9951 15.6752L13.6084 16.4769C11.8209 17.506 10.3584 16.661 10.3584 14.6027V12.9993V11.396C10.3584 9.32685 11.8209 8.49268 13.6084 9.52185L14.9951 10.3235L16.3817 11.1252C18.1692 12.1544 18.1692 13.8443 16.3817 14.8735Z",
    fill: "#13A846"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVideoCircle);
export default ForwardRef;